var FORM_INDEX = "__MANTINE_FORM_INDEX__";
export { FORM_INDEX };